//#region src/transaction_state.ts
var TransactionState = /* @__PURE__ */ function(TransactionState) {
	TransactionState[TransactionState["None"] = 0] = "None";
	TransactionState[TransactionState["Uncommitted"] = 1] = "Uncommitted";
	TransactionState[TransactionState["Committed"] = 2] = "Committed";
	TransactionState[TransactionState["Void"] = 3] = "Void";
	TransactionState[TransactionState["UncommittedVoid"] = 4] = "UncommittedVoid";
	return TransactionState;
}(TransactionState || {});
//#endregion
export { TransactionState };

//# sourceMappingURL=transaction_state.js.map